export const SET_OSCILLOMETRY_VIEW = 'SET_OSCILLOMETRY_VIEW';
export const SET_OSCILLOMETRY_REQUEST_ID = 'SET_OSCILLOMETRY_REQUEST_ID';
export const SET_OSCILLOMETRY_TEST_STARTED = 'SET_OSCILLOMETRY_TEST_STARTED';
export const SET_OSCILLOMETRY_RESULT = 'SET_OSCILLOMETRY_RESULT';
export const SET_OSCILLOMETRY_ERROR = 'SET_OSCILLOMETRY_ERROR';
export const SET_OSCILLOMETRY_READBACK = 'SET_OSCILLOMETRY_READBACK';
export const SET_OSCILLOMETRY_CANONICAL_SESSION = 'SET_OSCILLOMETRY_CANONICAL_SESSION';
export const RESET_OSCILLOMETRY_STATE = 'RESET_OSCILLOMETRY_STATE';
export const SET_OSCILLOMETRY_VISIT_LABELS = 'SET_OSCILLOMETRY_VISIT_LABELS';
export const SET_OSCILLOMETRY_IQC_PERSIST_STATUS = 'SET_OSCILLOMETRY_IQC_PERSIST_STATUS';
